import React, {useState} from 'react'

// Components
import CartRemoveDialog from './CartRemoveDialog'
import ModifyItem from '../ModifyItem/ModifyItem'

// Material UI
import { Button } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Drawer from '@material-ui/core/Drawer'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

// Style
import { makeStyles } from '@material-ui/core/styles'

// Icons
import DeleteIcon from '@material-ui/icons/Delete'
//import EditIcon from '@material-ui/icons/Edit'

const useStyles = makeStyles((theme) => ({
    card: {
        background: "white",
        cursor: "pointer",
        marginTop: 15,
        marginBottom: 15,
        marginLeft: 15,
        marginRight: 15,
    },
}));

export default function CartItem({ cartItem }) {

    const [open, setOpen] = useState(false)
    const [openDrawer, setOpenDrawer] = useState()

    const styles = { alignItems: "baseline" }
    const classes = useStyles();

    const handleDialog = () => {
        setOpen(open => !open)
    }

    const toggleDrawer = () => {
        setOpenDrawer(!openDrawer)
    }

    const replaceTheExtraWord = (ingredient) => {
        return ingredient.replace(/EXTRA/, "")
    }

    const calculateItemPrice = (cartItem) => {

        let amount
        const { quantity, price, priceTotalOptions, highestPrice } = cartItem

        if (highestPrice || (price === 0 && priceTotalOptions !== 0))
            amount = quantity * (price + priceTotalOptions)            
        else
            amount = quantity * price

        return amount.toFixed(2)
    }

    const calculateItemOptionPrice = (cartItem, item) => {

        let amount
        const { quantity, price, priceTotalOptions, highestPrice } = cartItem

        if (highestPrice || (price === 0 && priceTotalOptions !== 0))
            amount = ''
        else
            amount = (quantity * item.Price).toFixed(2) + "$"

        return amount
    }

    const calculateItemIngPrice = (cartItem, item) => {
        return (cartItem.quantity * item.price).toFixed(2)
    }

    return (
        <>
            <Card className={classes.card}>
                <CardContent>
                    <Grid justify="space-between" container style={styles}>
                        <Grid item>
                            <Typography variant="h6">{cartItem.quantity} x {cartItem.name}</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">{calculateItemPrice(cartItem)}</Typography>
                        </Grid>
                    </Grid>
                    {cartItem.subOptions.length !== 0 &&
                        <>
                            {cartItem.subOptions.map((option) =>
                                option.choices.map((item) =>
                                    <div key={item.UID}>
                                        <Grid justify="space-between" container style={styles}>
                                            <Grid item>
                                                {item.Name}
                                            </Grid>
                                            <Grid item>
                                                {item.Price !== 0 && calculateItemOptionPrice(cartItem, item)}
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                    </div>
                                )
                            )}
                        </>
                    }
                    {cartItem.subIngredients.length !== 0 &&
                        <>
                            {cartItem.subIngredients.map((ingredient) =>
                                <div key={ingredient.UID}>
                                    <Grid justify="space-between" container style={styles}>
                                        <Grid item>
                                            {ingredient.value === '+' && "MORE " + replaceTheExtraWord(ingredient.name)}
                                            {ingredient.value === 'w' && "WITHOUT " + replaceTheExtraWord(ingredient.name)}
                                        </Grid>
                                        <Grid item>
                                            {ingredient.price !== 0 && calculateItemIngPrice(cartItem, ingredient) + "$"}
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                </div>
                            )}
                        </>
                    }
                    {cartItem.notes !== "" &&
                        <>
                            <h4>Special Instructions: {cartItem.notes}</h4>
                        </>
                    }
                    <div style={{ float: "right", paddingTop: 10, paddingBottom: 10 }}>
                        <Button style={{ borderRadius: "15em", color: "red" }} onClick={() => handleDialog()} variant="contained" size="medium" >
                            <DeleteIcon />
                        </Button>
                        {/* <Button onClick={() => toggleDrawer()} variant="contained" size="large" color="primary" >
                        <EditIcon />
                    </Button> */}
                    </div>
                </CardContent>
            </Card>
            <Drawer open={openDrawer} anchor="right">
                <ModifyItem cartItem={cartItem} toggleDrawer={toggleDrawer} />
            </Drawer>
            <CartRemoveDialog open={open} item={cartItem} handleDialog={handleDialog} />
        </>
    )

}